import { render, staticRenderFns } from "./DayView.vue?vue&type=template&id=487ae0b2"
import script from "./DayView.ts?vue&type=script&lang=ts&external"
export * from "./DayView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports